<div class="grid gap-4 animate-pulse">
  <div
    class="bg-G200 w-full h-[120px] md:h-[170px] lg:h-[250px] rounded-xl"
  ></div>
  <div class="flex flex-col gap-2">
    <div
      class="w-full h-[15px] md:h-[18px] lg:h-[22px] bg-G300 rounded-full"
    ></div>
    <div
      class="w-full h-[14px] md:h-[16px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
    <div
      class="w-full h-[14px] md:h-[16px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
    <div
      class="w-[120px] h-[14px] md:h-[16px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
  </div>
  <div class="flex flex-wrap gap-2">
    <div
      class="w-[40px] h-[12px] md:h-[14px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
    <div
      class="w-[40px] h-[12px] md:h-[14px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
    <div
      class="w-[40px] h-[12px] md:h-[14px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
    <div
      class="w-[40px] h-[12px] md:h-[14px] lg:h-[18px] bg-G300 rounded-full"
    ></div>
  </div>
  <div class="flex items-center gap-6">
    <div
      class="w-[48px] h-[48px] bg-G100 rounded-full border-4 border-G100 overflow-hidden"
    >
      <svg
        class="w-full h-full me-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="#E2E8F0"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"
        />
      </svg>
    </div>
    <div class="w-full grid gap-2">
      <div
        class="w-full h-[14px] md:h-[16px] lg:h-[18px] bg-G300 rounded-full"
      ></div>
      <div
        class="w-[100px] h-[14px] md:h-[16px] lg:h-[18px] bg-G300 rounded-full"
      ></div>
    </div>
  </div>
</div>
